import {
	browserProfilingIntegration,
	browserTracingIntegration,
	captureException,
	replayIntegration,
	init as sentryInit,
	setTag,
	setUser,
	withProfiler,
} from '@sentry/react'

import { isProd } from '@/constants/env'
import { SENTRY_DSN } from './config'
import { beforeSend } from './handlers'

const CONFIGS = {
	REPLAY: {
		networkDetailAllowUrls: [
			window.location.origin,
			/^https:\/\/api\.ruguoapp\.com/,
			/^https:\/\/.*\.okjike\.com/,
			/^https:\/\/api\.qiniu\.com/,
		],
		networkRequestHeaders: ['X-Business-Role'],
		networkResponseHeaders: ['X-Envoy-Upstream-Service-Time', 'X-Request-Id', 'X-Server'],
		maskAllText: false,
		maskAllInputs: false,
		unblock: ['svg'],
	} as Parameters<typeof replayIntegration>[0],
	generate: (): Parameters<typeof sentryInit>[0] => ({
		dsn: SENTRY_DSN,
		integrations: [
			browserProfilingIntegration(),
			browserTracingIntegration(),
			replayIntegration(CONFIGS.REPLAY),
		],
		ignoreErrors: [
			// https://forum.sentry.io/t/unhandledrejection-non-error-promise-rejection-captured-with-value
			'Non-Error exception captured',
			'Non-Error promise rejection captured',
		],
		beforeSend,
		tracesSampleRate: 1.0,
		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0,
	}),
}

const init = () => {
	if (!isProd) return
	sentryInit(CONFIGS.generate())
}

const Sentry = {
	CONFIGS,
	init,
	withProfiler,
	captureException,
	setUser,
	setTag,
}
export default Sentry
